<template>
  <div class="about-container">
    <div class="about-content">
      <div v-if="showCloseBtn" class="close-btn" @click="handleClose">
        <span>×</span>
      </div>
      <h1 class="about-title">{{ title || '山东省心理咨询行业协会' }}</h1>
      <div class="about-text" v-html="content || defaultContent"></div>
      <div class="meta-info" v-if="author || create_time">
        <span v-if="author" class="author">{{ author }}</span>
        <span v-if="create_time" class="create-time">{{ create_time }}</span>
      </div>
      
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import article from '@/api/article'
import { setDocumentTitle } from '@/utils/title'
import { DEFAULT_SHARE_IMAGE, setWechatShare } from '@/utils/wechatShare'

const props = defineProps({
  id: {
    type: [String, Number],
    required: true
  },
  showCloseBtn: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['close'])

const route = useRoute()
const router = useRouter()

// 文章详情数据
const title = ref('')
const content = ref('')
const author = ref('')
const create_time = ref('')

const handleClose = () => {
  // 如果有父组件监听 close 事件，触发它
  if (emit) {
    emit('close')
  }
  // 否则返回上一页
  router.back()
}

const defaultContent = ``

// 获取文章详情
const fetchDetail = async (id) => {
  try {
    const res = await article.getDetail({ id })
    if (res && res.code === 2000) {
      const data = res.data
      title.value = data.title || ''
      content.value = data.content || ''
      author.value = data.author || ''
      create_time.value = data.create_time || ''
      setDocumentTitle(title.value)
      setWechatShare({
        title: title.value,
        desc: data.description || content.value,
        imgUrl: DEFAULT_SHARE_IMAGE,
        link: window.location.href.split('#')[0]
      })
    }
  } catch (err) {
    console.error('获取文章详情失败:', err)
  }
}

// 组件挂载时获取详情
onMounted(() => {
  const id = props.id || route.params.id
  if (id && id !== '0') {
    fetchDetail(id)
  }
})
</script>

<style scoped>
.about-container {
  width: 100%;
  padding: 60px 20px 80px;
  box-sizing: border-box;
}

.about-content {
  max-width: 1200px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 60px 80px;
  position: relative;
  box-sizing: border-box;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #f5f5f5;
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 10;
}

.close-btn:hover {
  background-color: #e0e0e0;
  transform: rotate(90deg);
}

.close-btn span {
  font-size: 28px;
  color: #666;
  line-height: 1;
  font-weight: 300;
}

.about-title {
  font-size: 32px;
  color: #333333;
  text-align: center;
  margin-bottom: 40px;
  font-weight: 500;
  position: relative;
  padding-bottom: 20px;
}

.about-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(to right, #4a9ff5, #5eb3f6);
  border-radius: 2px;
}

.meta-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
  margin-bottom: 30px;
  font-size: 16px;
  color: #444;
}

.meta-info .author,
.meta-info .create-time {
  color: #444;
}

.about-text {
  color: #666666;
  line-height: 2;
  font-size: 16px;
}

.about-text p {
  margin-bottom: 24px;
  text-indent: 2em;
  text-align: justify;
}

.about-text p:last-child {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .about-content {
    padding: 40px 20px;
  }
  
  .about-title {
    font-size: 24px;
  }
  
  .about-text {
    font-size: 14px;
  }
}
</style>
